( function ( $ ) {
	var hvac_dealer = $( '.content-with-sidebar' )[0];
	var class_names = ( hvac_dealer ) ? [ 'hvac-dealer-modal' ] : [];
	var modal = new tingle.modal( {
		closeMethods: [ 'overlay', 'escape' ],
		cssClass: class_names,
	} );

	var content = $( '.hvac-hyperlink-modal' ).html();
	modal.modal.style.zIndex = 5000;
	modal.setContent( content );

	$( '.hvac-dealer-hyperlink' ).click( function() {
		modal.open();
	} );

	$( '.hvac-hyperlink-modal--close' ).click( function() {
		modal.close();
	} );
} )( jQuery );



// WEBPACK FOOTER //
// ./assets/js/partials/hvac-hyperlink-modal.js